// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__552km","name":"styles_name__3LAIc","phone":"styles_phone__3GXCD"};